<template>
  <div style="height: 100% !important" class="d-flex flex-column flex-root">

    <!-- Loader - Démarrage applicatif -->
    <Loader v-if="loaderEnabled" v-bind:logo="loaderLogo"></Loader>

    <!-- Body -->
    <div class="d-flex flex-row flex-column-fluid page">
      <div id="kt_wrapper" class="d-flex flex-column flex-row-fluid wrapper">
        <!--Content -->
        <div
          id="kt_content"
          class="content d-flex flex-column flex-column-fluid"
        >
          <!-- Content Head -->
          <div class="d-flex justify-end">
            <div class="d-flex flex-row">
              <a
                @click="onClickConnectButton"
                class="btn btn-primary align-self-end m-3"
                >{{ $t("login.signIn") }}</a
              >
            </div>
          </div>

          <!-- Content Body -->
          <div class="flex-column-fluid container">
            <transition name="fade-in-up">
              <div>
                <!-- Logo -->
                <div class="divPrinc">
                  <div
                    style="
                      display: flex;
                      justify-content: center;
                      align-items: center;
                    "
                  >
                    <v-img src="media/logo/logoTMG.png" max-width="50%" />
                  </div>
                  <div style="margin-top: 4%">
                  <h2 class="titreForm" v-html="$t('home.popup.register_title')"/>
                  <hr class="mx-auto" width="50%" style="margin: 2%" />
                  <p class="sousTitreForm"
                    v-html="$t('home.popup.register_message', {videosAuthorized : 10})"
                  />
                  </div>
                </div>
                <hr class="mx-auto" width="80%" style="margin-top: 3%" />

                <!-- Formulaire -->
                <v-form ref="form">
                  <v-container>
                    <v-row no-gutters style="margin-bottom: 5px">
                      <v-col class="pa-1 ma-1">
                        <!-- Nom de l'utilisateur -->
                        <v-text-field
                          v-model="form.lastName"
                          :label="`${$t('common.user.lastname')} *`"
                          :rules="[
                            (v) =>
                              !!v ||
                              $t('common.form.required_field', {
                                field: $t('common.user.lastname'),
                              }),
                          ]"
                          background-color="white"
                          solo
                          clearable
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col class="pa-1 ma-1">
                        <!-- Prénom de l'utilisateur -->
                        <v-text-field
                          v-model="form.firstName"
                          :label="`${$t('common.user.firstname')} *`"
                          :rules="[
                            (v) =>
                              !!v ||
                              $t('common.form.required_field', {
                                field: $t('common.user.firstname'),
                              }),
                          ]"
                          solo
                          clearable
                          required
                        ></v-text-field>
                      </v-col>
                      <v-responsive
                        width="100%"
                        style="height: 10px"
                      ></v-responsive>

                      <v-col class="pa-1 ma-1">
                        <!-- Email de l'utilisateur -->
                        <v-text-field
                          v-model="form.email"
                          :label="`${$t('common.user.email')} *`"
                          :rules="form.emailErrors"
                          solo
                          clearable
                          required
                        ></v-text-field>
                      </v-col>

                      <v-col class="pa-1 ma-1" style="position: relative; bottom: 15px;">
                        <!-- Téléphone de l'utilisateur -->
                        <VuePhoneNumberInput
                          style="box-shadow: 2px 1px 1px grey;"
                          v-model="form.phone"
                          class="my-5"
                          @update="phoneUpdate"
                          default-country-code="FR"
                          :preferred-countries="['FR', 'BE', 'DE']"
                          :border-radius="0"
                          valid-color="black"
                          error-color="#fd397a"
                          :translations="{
                            countrySelectorLabel: $t(
                              'common.form.phone_translations.countrySelectorLabel'
                            ),
                            countrySelectorError: $t(
                              'common.form.phone_translations.countrySelectorError'
                            ),
                            phoneNumberLabel: $t(
                              'common.form.phone_translations.phoneNumberLabel'
                            ),
                            example: $t(
                              'common.form.phone_translations.example'
                            ),
                          }"
                        />
                      </v-col>
                      <v-responsive
                        width="100%"
                        style="height: 10px"
                      ></v-responsive>

                      <v-col class="pa-1 ma-1">
                        <!-- Entreprise de l'utilisateur -->
                        <v-text-field
                          v-model="form.company"
                          :label="`${$t('common.user.company')} *`"
                          :rules="[
                            (v) =>
                              !!v ||
                              $t('common.form.required_field', {
                                field: $t('common.user.company'),
                              }),
                          ]"
                          solo
                          clearable
                        ></v-text-field>
                      </v-col>

                      <v-col class="pa-1 ma-1">
                        <v-autocomplete
                          v-model="form.tools"
                          :items="form.toolsItems"
                          solo
                          chips
                          deletable-chips
                          :label="$t('home.popup.tools_selection_label')"
                          multiple
                        >
                          <template v-slot:selection="data">
                            <v-chip
                              v-bind="data.attrs"
                              :input-value="data.selected"
                              close
                              dark
                              color="#e6057d"
                              @click="data.select"
                              @click:close="removeTool(data.item)"
                            >
                              {{ data.item }}
                            </v-chip>
                          </template>
                        </v-autocomplete>
                      </v-col>
                    </v-row>

                    <!-- Commentaire de l'utilisateur -->
                    <v-textarea
                      style="border-radius: 10px"
                      v-model="form.comment"
                      :label="$t('home.contact.comment')"
                      solo
                      clearable
                      :counter="2500"
                      :rules="[
                        (v) =>
                          !v ||
                          (v && v.length <= 2500) ||
                          $t('common.form.max_characters', { max: 2500 }),
                      ]"
                    ></v-textarea>
                  </v-container>

                  <small
                    class="mt-4 mb-5 font-italic font-weight-thin text-right"
                    >This site is protected by reCAPTCHA and the Google
                    <a
                      class="text-primary"
                      target="_blank"
                      href="https://policies.google.com/privacy"
                      >Privacy Policy</a
                    >
                    and
                    <a
                      class="text-primary"
                      target="_blank"
                      href="https://policies.google.com/terms"
                      >Terms of Service</a
                    >
                    apply.</small
                  >

                  <v-checkbox
                    v-model="form.checkbox"
                    color="#e6007e"
                    :rules="[
                      (v) =>
                        !!v ||
                        $t('home.popup.register_accept_condition_mandatory'),
                    ]"
                    required
                    :label="$t('home.popup.register_accept_condition_label')"
                  ></v-checkbox>

                  <div class="d-flex flex-row justify-center">
                    <v-btn
                      style="border-radius: 20px"
                      class="btn-primary m-3"
                      @click="submit"
                      >Envoyer</v-btn
                    >
                  </div>
                </v-form>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
#kt_wrapper {
  padding-top: 0px !important;
  padding-left: 0px !important;
}
.sousTitreForm{
  font-size: 20px; 
  text-align: center; 
  margin-bottom: 2%;
}

.divPrinc{
  display: grid;
  grid-template-columns: 30% 70%;
  justify-content: center;
  align-items: center;
  margin-bottom: 2%;
}

.titreForm{
  font-size: 50px; 
  text-align: center;
}

.v-btn.btn-primary {
  background-color: #e6057d !important;
  border-color: #e6057d !important;
  color: white;
}

.v-btn.btn-primary:hover {
  background-color: #97175b !important;
  border-color: #97175b !important;
  color: white;
}
.v-btn.btn-primary:focus {
  background-color: #97175b !important;
  border-color: #97175b !important;
  color: white;
}
.v-btn.btn-primary::before {
  background-color: transparent !important;
}

@media (max-width: 1260px){
  .titreForm{
  font-size: 35px; 
  text-align: center;
  }
  .sousTitreForm{
    font-size: 15px; 
    text-align: center; 
    margin-bottom: 2%;
  }
}
</style>
<script>
import { mapGetters } from "vuex";
import HtmlClass from "@/core/services/htmlclass.service";
import Loader from "@/view/content/Loader.vue";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME,
} from "@/core/services/store/htmlclass.module.js";
import "vue-inner-image-zoom/lib/vue-inner-image-zoom.css";
import Api from "@/core/services/api.service";
import Swal from "sweetalert2";

// Import du RecaptchaV3
import Vue from "vue";
import { VueReCaptcha } from "vue-recaptcha-v3";

Vue.use(VueReCaptcha, {
  siteKey: process.env.VUE_APP_GOOGLE_RECAPTCHA_KEY_API,
  loaderOptions: {
    autoHideBadge: true,
  },
});

/*eslint no-control-regex: "off"*/
export default {
  name: "Register",
  components: {
    Loader,
    VuePhoneNumberInput,
  },
  data: function () {
    return {
      form: {
        lastName: "",
        firstName: "",
        email: "",
        phone: "",
        phoneNumber: null,
        phoneValid: false,
        company: "",
        tools: "",
        comment: "",
        toolsItems: [
          "Alteryx",
          "IBM Planning Analytics",
          "Jira",
          "Microstategy",
          "Peoplesoft",
          "Power BI",
          "SAP FC",
          "Trello",
          "Oracle",
          "Tagetik",
          "SailPoint",
        ],
        checkbox: "",
        emailErrors: [
          (v) => !!v || this.$i18n.t('common.form.required_field', { field: this.$i18n.t('common.user.email') }),
          (v) => /.+@.+\..+/.test(v) || this.$i18n.t('common.form.email_invalid')
        ],
        valid: false,
      },
    };
  },

  beforeMount() {
    // Si l'utilisateur est déjà connecté
    if (this.$store.getters.isAuthenticated) {
      this.$router.push({ name: "tableauDeBord" });
    }

    // Ajout du loader
    this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");

    // Initialisation des classes et élements HTML en fonction de la configuration
    HtmlClass.init(this.layoutConfig());
  },
  mounted() {
    // Gestion du loader
    setTimeout(() => {
      this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
    }, 2500);
  },

  methods: {
    phoneUpdate(updatedValue) {
      if (updatedValue && updatedValue.phoneNumber) {
        this.form.phoneNumber = updatedValue.phoneNumber;
        this.form.phoneCountry = updatedValue.countryCode;
        this.form.phoneValid = updatedValue.isValid;
      }
    },

    /* Méthode de routage vers la page d'accueil */
    onClickConnectButton() {
      this.$router.push({ name: "login" });
    },

    reloadPage() {
      window.location.reload();
    },

    removeTool(item) {
      const index = this.form.tools.indexOf(item);
      if (index >= 0) this.form.tools.splice(index, 1);
    },

    async submit(e) {
      e.preventDefault();
      //Si le formulaire n'est pas valide
      if (!this.$refs.form.validate()) {
        //console.log("non");
        return;
      }

      let self = this;
      try {
        // Attente du chargement du recaptcha
        await this.$recaptchaLoaded();
        // Demande de token à Google
        const token = await this.$recaptcha("register");
        // Vérification si token disponible
        if (!token) {
          // Pop-up
          Swal.fire({
            title: self.$i18n.t("home.api.register_failed.title"),
            html: self.$i18n.t(
              "home.api.register_failed.recaptcha_token_failed"
            ),
            icon: "error",
          });
          return;
        }
        // Envoi de la demande d'enregistrement
        Api.post("register", {
          firstname: self.form.firstName,
          lastname: self.form.lastName,
          email: self.form.email,
          phoneNumber: self.form.phoneNumber,
          phoneCountry: self.form.phoneCountry,
          company: self.form.company,
          tools: self.form.tools,
          comment: self.form.comment,
          "g-recaptcha-response": token,
        }).then(() => {
            Swal.fire({
              title: self.$i18n.t("home.api.register_success.title"),
              html: self.$i18n.t("home.api.register_success.message"),
              icon: "success",
            }).then(() => {
                self.reloadPage();
              });
          })
          .catch((error) => {
            // Définition du message d'erreur selon le code serveur
            let message = self.$i18n.t("home.api.register_failed.message");
            
            if (error.response && error.response.data) {
              switch (error.response.data) {
                case Api.ERRORS_CODE.WRONG_PARAMETERS:
                  message = self.$i18n.t(
                    "home.api.register_failed.wrong_parameters"
                  );
                  break;
                case Api.ERRORS_CODE.USER_ALREADY_EXIST:
                  message = self.$i18n.t(
                    "home.api.register_failed.user_already_exist"
                  );
                  break;
                case Api.ERRORS_CODE.RECAPTCHA_VERIFY_FAILED:
                  message = self.$i18n.t(
                    "home.api.register_failed.recaptcha_verify_failed"
                  );
                  break;
                case Api.ERRORS_CODE.USER_REGISTRATION_DISABLED:
                  message = self.$i18n.t(
                    "home.api.register_failed.user_registration_disabled"
                  );
                  break;
              }
            }
            // Pop-up
            Swal.fire({
              title: self.$i18n.t("home.api.register_failed.title"),
              html: message,
              icon: "error",
            });
          })
      } catch (error) {
        console.log(error);
        // Pop-up
        Swal.fire({
          title: self.$i18n.t("home.api.register_failed.title"),
          html: self.$i18n.t("home.api.register_failed.unknown_error"),
          icon: "error",
        });
      }
    },
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
      "currentUser",
    ]),

    /**
     * Check if the page loader is enabled
     * @returns {boolean}
     */
    loaderEnabled() {
      return !/false/.test(this.layoutConfig("loader.type"));
    },

    /**
     * Page loader logo image using require() function
     * @returns {string}
     */
    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig("loader.logo");
    },
  },
  metaInfo: {
    // Les enfants peuvent remplacer le titre.
    title: "Inscription",
    meta: [
      { "http-equiv": "Content-Type", content: "text/html; charset=utf-8" },
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        name: "description",
        content: "Inscription d'un utilisateur freemium à l'application TellMeGenius.",
      },
    ],
  },
};
</script>

